export default "* Evt. kegler eller lign. til at markere legeområdet\n* Evt. vest eller lign. til at markere hvem der er fangere\n";